import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import { sortObjectsByAlphabet } from "../../utils";
import * as urlService from "../../view/urlService";
import Select from "react-select";
import { TableContext } from "../../index";

function ChooseDeviceField({ setDeviceId, deviceId, devices = [] }) {

    const history = useHistory();
    //const [deviceId, setDeviceId] = useState();
    const { config, setConfig } = useContext(TableContext);

    const onChange = (value) => {
        setDeviceId(value);
        setConfig({ ...config, deviceId: value });

        if (Number(value) === -1) {
            //setConfig({...config, devices: []});           
            history.push({
                pathname: history.pathname,
                search: urlService.removeFilter('device')
            })
            return;
        }

        const device = devices.find(device => device.id === Number(value));

        if (device) {
            history.push({
                pathname: history.pathname,
                search: urlService.updateFilters('device', device.hostName)
            })
        }
    }

    let devicesToRender = devices; //.filter(device => device.deviceType.id === Number(selectedType));
    devicesToRender = sortObjectsByAlphabet(devicesToRender, 'hostName');

    // Create options for react-select
    const options = [
        { value: -1, label: 'Choose' },
        ...(devicesToRender || []).map(device => ({ value: device.id, label: device.hostName }))
    ];

    if (!devicesToRender || devicesToRender.length === 0) {
        options.push({ value: -2, label: 'No devices available', isDisabled: true });
    }

    return (
        <Select
            className="oct_selectsearch-v2"
            classNamePrefix="oct-selectsearchsub-v2"
            value={options.find(opt => opt.value === Number(deviceId)) || options[0]}
            onChange={(selectedOption) => onChange(selectedOption.value)}
            options={options}
            isSearchable={true}
            placeholder="Choose"
        />
    );
}

// function mapStateToProps(state) {
//     debug("DeviceTypeField mapStateToProps", state);
//     const analysisPage = state.analysisPage;
//     return {
//         devices: analysisPage.devices
//     };
// }

//export default connect(mapStateToProps)(ChooseDeviceField);
export default ChooseDeviceField;
